if (!window.Eurus.loadedScript.includes('locales-form.js')) {
  window.Eurus.loadedScript.push('locales-form.js');

  // Register Alpine component immediately to avoid timing issues
  const registerComponent = () => {
    if (window.Alpine && window.Alpine.data) {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
    } else {
      // Alpine not ready yet, try again in next frame
      requestAnimationFrame(registerComponent);
    }
  };

  // Try to register immediately or wait for Alpine
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerComponent);
  } else {
    registerComponent();
  }
}
